<template>
  <div class="bg-surface-canvas dark:bg-surface-level-900">
    <!-- No main navigation - SearchNavigation will be included in the page -->
    <slot />

    <Footer />
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '~/stores/useUserStore'
import { useLogger } from '~/composables/useLogger'
import { refreshStoredIdentity } from '~/utils/refreshStoredIdentity'

defineSlots<{
  default?: () => unknown
}>()

const nuxtApp = useNuxtApp()
const { isAuthenticated, refreshIdentity } = useIdentity()
const userStore = useUserStore()
const logger = useLogger('SearchLayout')

onMounted(async () => {
  try {
    await refreshStoredIdentity(nuxtApp, refreshIdentity)
  } catch (refreshError: unknown) {
    logger.warn('refreshIdentity', { refreshError })
  }
  if (isAuthenticated.value && !userStore.initialized) {
    await userStore.fetchUserAccess()
  }
})
</script>
